import { render, staticRenderFns } from "./changeplan.vue?vue&type=template&id=19b084e2&scoped=true"
import script from "./changeplan.vue?vue&type=script&lang=js"
export * from "./changeplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b084e2",
  null
  
)

export default component.exports